import React from 'react';

export interface Review {
  // NOTE: As of 2/17/23 these are all strings, but we can do any styling we want with tsx
  content: React.ReactNode;
  customerName: string;
  customerInfo?: string;
}

export const CUSTOMER_VOICES_REVIEWS: Review[] = [
  {
    content:
      "Your food is a staple in my home! I'm in the midst of starting my own startup & having healthy, tasty food that the whole family enjoys is such a godsend!",
    customerName: 'Kirthiga R.',
    customerInfo: 'Verified customer',
  },
  {
    content: 'Homemade food without excess of spices, oil or salt. I absolutely loved it!',
    customerName: 'Heena U.',
    customerInfo: 'Verified customer',
  },
  {
    content: "As folks without family nearby, it’s as close to comfort from our moms as it gets. We'll order again!",
    customerName: 'Regina G.',
    customerInfo: 'Verified customer',
  },
  {
    content: 'Everything tasted fresh and healthy, just like how my mom would make it.',
    customerName: 'Gayathri',
    customerInfo: 'Verified customer',
  },
  {
    content:
      'My husband and I needed to restrain ourselves from eating everything so there would be food left for our kids!',
    customerName: 'Susan O.',
    customerInfo: 'Verified customer',
  },
  {
    content: `I wish I could give you a hundred stars.`,
    customerName: 'Irene M.',
    customerInfo: 'Verified customer',
  },
  {
    content: 'Loved everything! It was all delicious and so flavorful! Prepared and packaged so conveniently.',
    customerName: 'Lecrecia N.',
    customerInfo: 'Verified customer',
  },
];

export const MEAL_PLAN_CUSTOMER_VOICES_REVIEWS: Review[] = [
  {
    content:
      'Thank you for going above and beyond to keep us and our kiddos happy & well fed. Our son is a hungry little guy and LOVES all of your dishes.',
    customerName: 'Soki O.',
    customerInfo: 'Verified customer',
  },
  {
    content: `As a mom, it's such a relief to know that we can count on the healthy, super tasty food I can put on the table (or floor in reality) without doing the cooking myself! Thank you!`,
    customerName: 'Mia C.',
    customerInfo: 'Verified customer',
  },
  {
    content:
      "I will DEFINITELY keep my subscription. The food tastes like it came directly from a mother's kitchen. AMAZING!",
    customerName: 'Nancy E.',
    customerInfo: 'Verified customer',
  },
  {
    content:
      "Really worth the price! Shef's new weekly plan is great for the weeks when you have no time to meal prep.",
    customerName: 'Cindy I.',
    customerInfo: 'Verified customer',
  },
  {
    content:
      "I love this woman's cooking! Especially because there's a lot of healthy options that are delicious but not too oily.",
    customerName: 'Rustin P.',
    customerInfo: 'Verified customer',
  },
  {
    content: `Incredible! Highly recommended. The food was very fresh and tasted amazing.`,
    customerName: 'Brit M.',
    customerInfo: 'Verified customer',
  },
];

export const DIETARY_REVIEWS = [
  {
    content: (
      <span>
        As someone who's struggled to stick to Whole 30 in the past, I'm thrilled to have found this food delivery
        service - their meals are both <b>satisfying and nutritious.</b>
      </span>
    ),
    customerName: 'Julia V.',
    customerInfo: 'Verified customer',
  },
  {
    content: (
      <span>
        As a non-vegan, I was blown away by how <b>delicious and creative</b> this vegan dish was!
      </span>
    ),
    customerName: 'David L.',
    customerInfo: 'Verified customer',
  },
  {
    content: (
      <span>
        As someone who keeps kosher, it's such a treat to find service that offers such a{' '}
        <b>variety of flavorful dishes</b> that I can actually eat.
      </span>
    ),
    customerName: 'Jenny F.',
    customerInfo: 'Verified customer',
  },
];

export const YOUNG_FAMILY_REVIEWS = [
  {
    content: (
      <span>
        The rosemary chicken with potatoes was a hit with the whole family. It's so nice to have a <b>healthy</b> and{' '}
        <b>delicious</b> meal <b>without any of the prep work.</b>
      </span>
    ),
    customerName: 'Ellen C.',
    customerInfo: 'Verified customer',
  },
  {
    content: (
      <span>
        As a busy mom, this meal planning service has been a lifesaver. The food is{' '}
        <b>healthy, tasty, and so easy to prepare.</b> I don't know how I managed without it!
      </span>
    ),
    customerName: 'Sophie R.',
    customerInfo: 'Verified customer',
  },
  {
    content: (
      <span>
        The shepherd's pie is a staple in our house and my kids beg for it every week. With this meal planning service,{' '}
        <b>dinner time has become a breeze.</b>
      </span>
    ),
    customerName: 'Rob T.',
    customerInfo: 'Verified customer',
  },
];

export const INDIAN_COMMUNITY_REVIEWS = [
  {
    content: (
      <span>
        “Real taste of home in the East Bay. The beef fry gave me <b>flashbacks of summers in Cochin.</b> Thank you Shef
        Jessy.”
      </span>
    ),
    customerName: 'Rahul M.',
    customerInfo: 'Verified customer',
  },
  {
    content: (
      <span>
        “Shef Renu’s Kadai Paneer had the <b>perfect balance of flavors</b> and a creamy consistency.”
      </span>
    ),
    customerName: 'Shalini G.',
    customerInfo: 'Verified customer',
  },
  {
    content: (
      <span>
        “Thank you Shef Supriya! The vada pav <b>reminds me of Mumbai</b> and it is such a relief not to have to worry
        about cooking and cleaning after work.”
      </span>
    ),
    customerName: 'Nitish V.',
    customerInfo: 'Verified customer',
  },
];

export const CHINESE_COMMUNITY_REVIEWS = [
  {
    content: <span>“Incredible Chinese dishes – the chef's skill is evident in every bite!”</span>,
    customerName: 'David L.',
    customerInfo: 'Verified customer',
  },
  {
    content: <span>“Authentic and delicious! The chef's love for Taiwanese cuisine really shines through.”</span>,
    customerName: 'Susan H.',
    customerInfo: 'Verified customer',
  },
  {
    content: <span>“Comfortingly familiar flavors, a true homage to authentic Chinese home cooking.”</span>,
    customerName: 'Jean Z.',
    customerInfo: 'Verified customer',
  },
];
export const HALAL_COMMUNITY_REVIEWS = [
  {
    content: (
      <span>
        “Finding a variety of quality Halal food has always been a struggle. Shef changed that. It's like{' '}
        <b>a global food tour</b> right from home!”
      </span>
    ),
    customerName: 'Zeinab J.',
    customerInfo: 'Verified customer',
  },
  {
    content: (
      <span>
        “This was the first time that I have EVER tried Sicilian food. I’m so grateful to Shef Tony for preparing halal
        ravioli. <b>You’ve given me such a gift.</b>”
      </span>
    ),
    customerName: 'Kamal M.',
    customerInfo: 'Verified customer',
  },
  {
    content: (
      <span>
        “This continues to be an <b>amazing experience for my family.</b> My husband and I have always felt restricted
        from ordering out. Now we can.”
      </span>
    ),
    customerName: 'Aisha C.',
    customerInfo: 'Verified customer',
  },
];
